<!-- <h4 class="py-4 text-center message">No {{message}}</h4> -->
<div class="row pt-4">
<div class="col-12 col-md-4">
<div class="info-box course-box success-card">
    <div class="text-center">
      <img class="card-icon" src="assets/img/clapping-icon.gif" alt="">
      <!-- You've completed your classes. -->
      <p class="mt-4 mb-5">Woohoo! <br>{{message.mainMessage}}</p> 
      <button *ngIf="message?.cta" type="button" class="btn-link" (click)="ActionHandling(message.cta)" >Click here</button> {{message.cta.message}}
    </div>
</div>
</div>
</div>
